import { Expose } from "class-transformer";
import { IsOptional } from "class-validator";

export class AiChatbotCmsPromptInputAttributes {
  @Expose()
  promptMessage!: string;

  @Expose()
  displayText!: string;
}

export class AiChatbotCmsPrompt {
  @Expose()
  active!: boolean;

  @Expose()
  priority!: number;

  @Expose()
  showIn!: string;

  @Expose()
  aiPromptInput!: AiChatbotCmsPromptInputAttributes;

  @Expose()
  @IsOptional()
  aiPromptPath: string | null = "";

  @Expose()
  defaultErrorResponse?: string;
}
